export let ManageModalScreenName;

(function (ManageModalScreenName) {
  ManageModalScreenName[ManageModalScreenName["CharitySelect"] = 0] = "CharitySelect";
  ManageModalScreenName[ManageModalScreenName["Overview"] = 1] = "Overview";
})(ManageModalScreenName || (ManageModalScreenName = {}));